import { Location } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { KeycloakLinkGenerator } from '@planone/bau365/util-keycloak';
import { KeycloakService } from 'keycloak-angular';
import { Subject } from 'rxjs';

@Component({
  selector: 'planone-unauthorized-modal',
  templateUrl: './unauthorized-modal.component.html',
  styleUrls: ['./unauthorized-modal.component.scss'],
})
export class UnauthorizedModalComponent implements OnInit, OnDestroy {
  loginLink = '';
  registrationLink = '';
  previousUrlIsExternal: boolean | undefined;
  closable = false;
  fairId: string;
  redirectUri: string;

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public dialog: MatDialog,
    private keycloakService: KeycloakService,
    private keycloakLinkGenerator: KeycloakLinkGenerator,
    private location: Location,
    private dialogRef: MatDialogRef<UnauthorizedModalComponent>,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.closable = !this.dialogRef.disableClose;
    this.fairId = data.fairId;
    this.redirectUri = data.redirectUri;
  }

  ngOnInit() {
    this.previousUrlIsExternal = typeof history !== 'undefined' ? history?.state?.navigationId === 1 : false;
    if (this.fairId) {
      this.loginLink = this.keycloakLinkGenerator.createLoginUrl({
        locale: this.localeId,
        fairId: this.fairId,
        redirectUri: this.redirectUri,
      });
      this.registrationLink = this.keycloakLinkGenerator.createRegisterUrl({
        locale: this.localeId,
        fairId: this.fairId,
      });
    }
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
